class GoldstarPersonalizer extends HTMLElement {
  constructor() {
    super();
    this.modeInputs = this.querySelectorAll('.goldstar-personalizer__mode-input');
    this.methodWrapper = this.querySelector('.goldstar-personalizer__method');
    this.methodSelect = this.querySelector('.goldstar-personalizer__method-select');
    this.setupFeeEl = this.querySelector('.goldstar-personalizer__setup-fee');
    this.textField = this.querySelector('.goldstar-personalizer__field--text');
    this.logoField = this.querySelector('.goldstar-personalizer__field--logo');
    this.textInput = this.textField ? this.textField.querySelector('input[type="text"]') : null;
    this.fileInput = this.logoField ? this.logoField.querySelector('input[type="file"]') : null;
    this.counter = this.querySelector('.goldstar-personalizer__counter');
    this.previewWrapper = this.querySelector('.goldstar-personalizer__preview');
    this.previewText = this.querySelector('.goldstar-personalizer__preview-text');
    this.previewImage = this.querySelector('.goldstar-personalizer__preview-image');
    this.objectUrl = null;

    try {
      this.methods = JSON.parse(this.dataset.methods || '[]');
    } catch (e) {
      this.methods = [];
    }
    try {
      this.feeVariants = JSON.parse(this.dataset.feeVariants || '{}');
    } catch (e) {
      this.feeVariants = {};
    }
    this.feeLabelTemplate = this.dataset.feeLabelTemplate || '';
    this.feeFreeLabel = this.dataset.feeFreeLabel || '';

    this.currentMode = 'none';
    this.maxChars = 30;

    this.modeInputs.forEach((input) => {
      input.addEventListener('change', this.onModeChange.bind(this));
    });
    if (this.methodSelect) this.methodSelect.addEventListener('change', this.onMethodChange.bind(this));
    if (this.textInput) this.textInput.addEventListener('input', this.onTextInput.bind(this));
    if (this.fileInput) this.fileInput.addEventListener('change', this.onFileChange.bind(this));

    this.refreshForSelectedMethod();

    const form = this.closest('form');
    if (form) form.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  selectedMethod() {
    const index = this.methodSelect
      ? this.methodSelect.selectedOptions[0]?.dataset.index
      : 0;
    return this.methods[parseInt(index || '0', 10)] || this.methods[0] || {};
  }

  refreshForSelectedMethod() {
    const method = this.selectedMethod();
    this.maxChars = method.max_characters || 30;
    if (this.textInput) this.textInput.setAttribute('maxlength', this.maxChars);
    if (this.counter) {
      const template = this.counter.dataset.template || '';
      this.counter.textContent = template.replace('__COUNT__', this.maxChars);
    }
    this.updateSetupFeeDisplay(method);
  }

  onMethodChange() {
    this.refreshForSelectedMethod();
  }

  updateSetupFeeDisplay(method) {
    if (!this.setupFeeEl) return;
    const showFee = this.currentMode === 'text' || this.currentMode === 'logo';
    if (!showFee) {
      this.setupFeeEl.hidden = true;
      return;
    }
    // Personnalisation offerte : toujours gratuit, quel que soit le cout reel du fournisseur.
    this.setupFeeEl.textContent = this.feeFreeLabel;
    this.setupFeeEl.hidden = false;
  }

  onModeChange(event) {
    const mode = event.target.value;
    this.currentMode = mode;
    const isText = mode === 'text';
    const isLogo = mode === 'logo';
    const isPersonalizing = isText || isLogo;

    if (this.textField) this.textField.hidden = !isText;
    if (this.logoField) this.logoField.hidden = !isLogo;
    if (this.textInput) this.textInput.disabled = !isText;
    if (this.fileInput) this.fileInput.disabled = !isLogo;
    if (this.methodWrapper) this.methodWrapper.hidden = !isPersonalizing;
    if (this.previewWrapper) this.previewWrapper.hidden = !isPersonalizing;

    if (!isText && this.previewText) this.previewText.textContent = '';
    if (!isLogo) this.clearImagePreview();

    this.updateSetupFeeDisplay(this.selectedMethod());
  }

  onTextInput(event) {
    const value = event.target.value;
    if (this.previewText) this.previewText.textContent = value;
    if (this.counter) {
      const remaining = Math.max(0, this.maxChars - value.length);
      const template = this.counter.dataset.template || '';
      this.counter.textContent = template.replace('__COUNT__', remaining);
    }
  }

  onFileChange(event) {
    const file = event.target.files && event.target.files[0];
    this.clearImagePreview();
    if (!file || !this.previewImage) return;
    this.objectUrl = URL.createObjectURL(file);
    this.previewImage.src = this.objectUrl;
    this.previewImage.hidden = false;
  }

  clearImagePreview() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
    if (this.previewImage) {
      this.previewImage.hidden = true;
      this.previewImage.removeAttribute('src');
    }
  }

  onFormSubmit() {
    // Personnalisation offerte : plus de frais de mise en route ajoutes au panier.
    return;
  }
}

customElements.define('goldstar-personalizer', GoldstarPersonalizer);
